import React from 'react'

export const BoxListSettings = (props) => <></>